import { homePage as homePageEn } from './en/homePage.locale';
import { homePage as homePageVi } from './vi/homePage.locale';
import { homePage as homePageJp } from './jp/homePage.locale';
import { homePage as homePageKo } from './ko/homePage.locale';
import { homePage as homePageRu } from './ru/homePage.locale';
import { homePage as homePageZh } from './zh/homePage.locale';
import { collection as collectionEn } from './en/collection.locale';
import { collection as collectionVi } from './vi/collection.locale';
import { collection as collectionJp } from './jp/collection.locale';
import { collection as collectionKo } from './ko/collection.locale';
import { collection as collectionRu } from './ru/collection.locale';
import { collection as collectionZh } from './zh/collection.locale';
import { changePassword as changePasswordEn } from './en/changePassword.locale';
import { changePassword as changePasswordVi } from './vi/changePassword.locale';
import { changePassword as changePasswordJp } from './jp/changePassword.locale';
import { changePassword as changePasswordKo } from './ko/changePassword.locale';
import { changePassword as changePasswordRu } from './ru/changePassword.locale';
import { changePassword as changePasswordZh } from './zh/changePassword.locale';
import { newFeatures as newFeaturesEn } from './en/newFeatures.locale';
import { newFeatures as newFeaturesVi } from './vi/newFeatures.locale';
import { newFeatures as newFeaturesJp } from './jp/newFeatures.locale';
import { newFeatures as newFeaturesKo } from './ko/newFeatures.locale';
import { newFeatures as newFeaturesRu } from './ru/newFeatures.locale';
import { newFeatures as newFeaturesZh } from './zh/newFeatures.locale';
export const homePageLocale = {
    en: {
        homePage: homePageEn,
        collection: collectionEn,
        changePassword: changePasswordEn,
        newFeatures: newFeaturesEn
    },
    vi: {
        homePage: homePageVi,
        collection: collectionVi,
        changePassword: changePasswordVi,
        newFeatures: newFeaturesVi

    },
    jp: {
        homePage: homePageJp,
        collection: collectionJp,
        changePassword: changePasswordJp,
        newFeatures: newFeaturesJp

    },
    ru: {
        homePage: homePageRu,
        collection: collectionRu,
        changePassword: changePasswordRu,
        newFeatures: newFeaturesRu

    },
    ko: {
        homePage: homePageKo,
        collection: collectionKo,
        changePassword: changePasswordKo,
        newFeatures: newFeaturesKo

    },
    zh: {
        homePage: homePageZh,
        collection: collectionZh,
        changePassword: changePasswordZh,
        newFeatures: newFeaturesZh

    },
};
